// File exists purely to not have stupid issues with git pulls

//export const core_site = "http://localhost:3002";
export const core_site = "https://mymeanderingmind.com:3002";
